import React from "react"
import styled from "styled-components"
import LazyLoad from "react-lazyload"

import useSiteMetadata from "../../hooks/use-site-metadata"

const Wrapper = styled.div`
  height: 0;
  padding-bottom: 56.25%;
  position: relative;
  overflow: hidden;
  width: 100%;

  iframe {
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`

const Maps = ({ src }) => {
  const { googleMapsApiKey, lang } = useSiteMetadata()
  return (
    <Wrapper>
      <LazyLoad offset={150} once>
        <iframe
          width="960"
          height="540"
          src={`${src}&key=${googleMapsApiKey}&language=${lang}`}
          frameBorder="0"
          allowFullScreen
          title="Map"
        />
      </LazyLoad>
    </Wrapper>
  )
}

export default Maps
